// extracted by mini-css-extract-plugin
module.exports = {"PrivacyReminder":"np_a pz_nz pz_a pz_j pz_q pz_rf pz_qn","PrivacyReminder__btnLabel":"np_b"};